export class BAPIError extends Error {
  public readonly status?: number;
  public readonly aborted?: boolean;

  constructor(msg: string, status?: number, cause?: Error, aborted?: boolean) {
    super(msg, { cause });

    if (status) {
      this.status = status;
    }

    if (aborted) {
      this.aborted = aborted;
    }
  }
}
